export default "__VITE_ASSET__17c0d95b__"